import { useEffect } from "react";
import * as Client from "api/client";
import { useAuth } from "providers/Auth";

function getCookie() {
  const rawCookie = document.cookie || "";
  const cookie = rawCookie.split(";").reduce((a, b) => {
    const [key, value] = b.split("=").map((str) => str.trim());
    a[key] = value;
    return a;
  }, {});
  return cookie;
}

export default function Ecid({ children }) {
  const { auth, validAuth } = useAuth();

  useEffect(() => {
    if (!validAuth) return;
    const cookie = getCookie();
    const ecid = cookie["ecid"] || "";
    if (ecid) Client.bindEcid(auth.userId, auth.idToken, auth.accessToken, ecid);
  }, [auth, validAuth]);

  return <>{children}</>;
}
